import { render } from "./RolesView.vue?vue&type=template&id=c53d6140&ts=true"
import script from "./RolesView.vue?vue&type=script&lang=ts"
export * from "./RolesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__